exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/julien/code/urbyn/urbyn-backoffice/src/app/haulers/haulers-list/haulers-list.component.css
// module id = ../../../../../src/app/haulers/haulers-list/haulers-list.component.css
// module chunks = main